import React, { useState } from "react";
import UserHeader from "./UserHeader";
import { usersMetadata } from "../../../data/metadata/tabsMetadata";
import UsersList from "./UsersList";

export default function User({
  userList,
  updateUser,
  deleteUser,
  onUserCreate,
  updatePassword,
}) {
  const [users, setUsers] = useState([]);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [searchFiled, setSearchField] = React.useState("");

  const filterUserList = (value) => () => {
    const searchedUsers = userList.filter((u) =>
      u.name.toLowerCase().includes(searchFiled.toLocaleLowerCase())
    );

    if (value == null) {
      setUsers(searchedUsers);
      return;
    }

    setUsers(searchedUsers.filter((u) => u.active === value));
  };

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const withoutTabChange = () => {
    if (tabIndex === 0) filterUserList(null)();
    else if (tabIndex === 1) filterUserList(true)();
    else filterUserList(false)();
  };

  const updateSearchFiled = (event) => {
    setSearchField(event.target.value);
  };

  React.useEffect(() => {
    withoutTabChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList, searchFiled]);

  return (
    <div style={{ padding: "24px 40px" }}>
      <UserHeader
        tabConfig={usersMetadata(filterUserList)}
        tabIndex={tabIndex}
        onTabChange={handleTabChange}
        onUserCreate={onUserCreate}
        onSearch={updateSearchFiled}
        search={searchFiled}
      />
      <UsersList
        userList={users}
        updateUser={updateUser}
        deleteUser={deleteUser}
        updatePassword={updatePassword}
      />
    </div>
  );
}
